import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { AssessmentDto } from '../shared/model/assessment-dto';
import { ScheduleDrive } from '../shared/model/hr-dto';
import { ApiResponse } from '../shared/model/response-format';
import { AppClient } from '../../environments/client';
import { environment } from 'src/environments/environment';

export interface RecommendModalData {
  srNumber: string;
  selectedCandidateIds: Set<string>;
  // Add the actual list objects here to pass them up directly
  recommendedCandidateList: any[];
  profilesToSendMail: any[];
  srDetailsToSendMail: any;
  onSuccessCallback?: () => void;
}

export interface RecommendModalWrapper {
  isOpen: boolean;
  data: RecommendModalData | null;
}

// Define a wrapper interface
export interface RejectModalWrapper {
  isOpen: boolean;
  data: RejectModalData;
  isBackButtonVisible?: boolean;
}
export interface RejectModalData {
  srNumber: string;
  employeeId?: string; 
  optionKey?: string; 
  data:any;
  successCallbackForRejectedRecommended?: () => void;
  onCloseRejectedRecommendedPopupCallback?: () => void;
  emitActionsToBeTaken :string,
  isBackButtonVisible?:boolean,
  isOpen?:boolean
}

export interface BlockCandidateModalData {
  srNumber: string;
  designation?: string;
  srDetailsToSendMail?: any;
  selectedCandidateList: any[];
  isBackButtonVisible?:boolean,
  successCallbackForblockCandidateCallBack?: (actionType: string) => void;
  onCloseBlockCandidateCallback?: () => void;
}

export interface UnmapCandidateModalData {
  srNumber: string;
  candidates: Array<{ employeeName?: string; employeeId?: string }>;
  isBackButtonVisible?: boolean;
  successCallbackForUnmapCandidate?: (
    employeeDetails: Array<{ employeeId: string; reason: string }>,
  ) => Promise<boolean> | boolean;
  onCloseUnmapCandidateCallback?: () => void;
}


@Injectable({
  providedIn: 'root',
})
export class StaffingService {
  deployedClient = environment.deployedClient;

  baseUrl = environment.baseUrl;
  videoMerge = environment.videoMergeFeed;
  apiUrls = {
    addScheduleDrive: '/api/v1/drive-config/schedule',
    getAssessmentDetails: '/api/v1/assessment-config/get-all-assessment',
    getDriveDetails: '/api/v1/drive-config/get-all',
    getDriveById: '/api/v1/drive-config/get-by-id/',
    getAllUsersOfDrive: '/api/v1/drive-config/get-all-users-of-drive',
    getAllInvitedUsersOfDrive:
      '/api/v1/drive-config/get-workday-drive-users-data',
    candidateViewDetails: '/api/v1/drive-config/get-assessment-score',
    downloadReports: '/api/v1/reports/user/download-data',
    getCandidateProfileById: '/api/v1/user/get-candidate-profile-details/',
    downloadReportsForAllCandidates:
      '/api/v1/reports/drive-config/download-users-of-drive-in-excel/',
    generateReportsForDownload:
      '/api/v1/drive-config/generate-users-of-drive-in-excel/',
    mergeChunksInCandidate: '/api/v1/merge/merge-chunk-files-for-drive',
    unMergeChunkFiles: '/api/v1/file/get-user-feeds/',
    extendScheduledDrive: '/api/v1/drive-config/extend-and-end-drive',
    getAllPrimaryDrives: '/api/v1/drive-config/get-all-primary-drives',
    downloadMergedVideo:
      '/api/v1/reports/drive-config/download-merged-video-details',
    downloadMultipleDrive:
      '/api/v1/reports/drive-config/download-multiple-drives-report-in-excel',
    getShortlistDrive: '/api/v1/drive-config/get-all-to-schedule-new-drive',
    blackListCandidate: '/api/v1/user/block-candidate/',
    getAllCandidates: '/api/v1/drive-config/get-all-candidates',
    getAllConsolidatedReportPagination:
      '/api/v1/drive-config/find-all-consolidated-reports',
    mergeAllCandidateFeeds: '/api/v1/merge/merge-candidate-video-by-drive/',
    downloadProctoringReport:
      '/api/v1/reports/user/download-proctoring-details/',
    sendMailToUser: '/api/v1/drive-config/send-mail-drive-users',
    shortListByDrive: '/api/v1/short-listed/shortlist-candidate-by-drive',
    getShortListedData: '/api/v1/short-listed/get-shortlisted-candidates',
    uploadCSVFile: '/api/v1/drive-config/summary-csv-file',
    AIProctoringResult: '/api/v1/drive-config/get-candidate-drive-report/',
    mergeShortlistedFeed:
      '/api/v1/reports/drive-config/download-merged-video-details-for-shortlisted-candidate/',
    shortListCandidates: '/api/v1/drive-config/save-shortlist-candidate',
    downloadAllVideoResponse:
      '/api/v1/reports/drive-config/download-candidate-video-folder-details/',
    downloadShortlistedVideoResponse:
      '/api/v1/reports/drive-config/download-candidate-video-folder-details-for-shortlisted-candidate/',
    mergeShortlistedCandidate:
      '/api/v1/merge/merge-shortlisted-candidate-chunks-by-drive/',
    downloadReportForShortlisted:
      '/api/v1/reports/drive-config/download-shortlisted-candidate-report-in-excel/',
    downloadAllReports:
      '/api/v1/reports/drive-config/download-all-reports-of-drive-in-excel/',
    saveShortlistType: '/api/v1/short-listed/save-shortlist-type-candidate',
    addCandidateToShortlist: '/api/v1/drive-config/add-candidate-to-shortlist',
    removeCandidateFromShortlist:
      '/api/v1/drive-config/Remove-candidate-from-shortlist',
    downloadQuestionExplanationReport:
      '/api/v1/reports/drive-config/download-candidate-pop-up-question-details/',
    getAllGeneratedReports:
      '/api/v1/drive-config/find-all-reports-generated-of-drive-in-excel/',
    downloadExcelReports:
      '/api/v1/reports/drive-config/download-excel-by-file-id/',
    downloadAllCandidateBotAssessmentReport:
      '/api/v1/reports/inter-bot-report/download-interview-report-by-fileName/',
    allAssessmentReport:
      '/api/v1/reports/drive-config/generate-users-of-drive-in-excel/',
    allCandidateBotAssessmentReport:
      '/api/v1/reports/inter-bot-report/generate-interview-report-excel-by-drive/',
    shortlistedAssessmentReport:
      '/api/v1/reports/drive-config/generate-shortlist-users-of-drive-in-excel/',
    allCandidateMergedUrl:
      '/api/v1/reports/drive-config/generate-all-users-of-drive-merged-urls-in-excel/',
    generateShortlistedMergedUrl:
      '/api/v1/reports/drive-config/generate-shortlist-users-of-drive-merged-urls-in-excel/',
    generateAllCandidateAssessmentSummaryReport:
      '/api/v1/reports/drive-config/generate-summary-all-users-of-drive-in-excel/',
    generateShortlistedCandidateAssessmentSummaryReport:
      '/api/v1/reports/drive-config/generate-summary-shortlist-users-of-drive-in-excel/',
    generateNonAttemptedCandidateAssessmentReport:
      '/api/v1/reports/drive-config/generate-not-attempted-users-of-drive-in-excel/',
    allInterviewResponse:
      '/api/v1/reports/drive-config/generate-all-users-of-drive-interview-responses-in-excel/',
    shortlistedInterviewResponse:
      '/api/v1/reports/drive-config/generate-shortlist-users-of-drive-interview-responses-in-excel/',
    QuestionExplanationReport:
      '/api/v1/reports/drive-config/generate-all-users-of-drive-pop-question-responses-in-excel/',
    detectedMonitorReport: '/api/v1/candidate-app-monitoring/get/',
    candidateAudioProcess: '/api/v1/assessment/candidate-audio-process',
    candidateProctoringProcess:
      '/api/v1/assessment/process-candidate-proctoring-result',
    candidateCodingResult: '/api/v1/assessment/candidate-coding-result',
    getPupularAssesment: '/api/v1/drive-config/get-popular-assessments',
    getcountActiveDrive: '/api/v1/drive-config/get-count-of-active-drives',
    experienceCandidateChart:
      '/api/v1/drive-config/get-candidate-experience-details',
    getAssessmentDetailDashboard:
      '/api/v1/drive-config/get-all-assessments-for-dashboard',
    saveDriveJD: '/api/v1/drive-config/save-drive-jd',
    chatBtwnBotAndCandidate:
      '/api/v1/assessment/get-candidate-interview-response-by-callId/',
    getInterviewBotScore:
      '/api/v1/candidate-audio-score/get-interview-bot-score/',
    getInterviewTimestamps: '/api/v1/assessment/get-interview-timestamps/',
    getProctoringImages: '/api/v1/assessment/get-proctoring-images/',
    sendCandidateEmail: '/api/v1/drive-config/send-mail-to-candidate/',
    twoWayReportGenerate:
      '/api/v1/reports/inter-bot-report/generate-interview-report-excel/',
    twoWayReportDownload:
      '/api/v1/reports/inter-bot-report/download-interview-report-by-callId/',
    resendReportsWorkdayForNoninterviewBot:
      '/api/v1/drive-config/send-candidate-reports-to-workday',
    resendReportsWorkdayInterviewBot:
      '/api/v1/reports/candidate-audio-score/trigger-interview-report-to-workday-by-drive',
    reEvaluateInterviewBot:
      '/api/v1/assessment/run-interview-bot-evaluation-by-callId/',
    resendInviteForWorkday:
      '/api/v1/drive-config/send-mail-to-pending-candidates',
    viewDrivesOfCandidateById: '/api/v1/drive-config/get-drives-of-candidate/',
    workDayConsolidatedErrors:
      '/api/v1/drive-config/workday-missing-report-users',
    resetPasswordForCandidate: '/api/v1/user/reset-candidate-password/',
    unblockCandidate: '/api/v1/user/unblock-candidate/',
    generateReportForWodayUsers:
      '/api/v1/reports/drive-config/download-invite-users-excel/',
    updateDriveStatus: (driveId: string) =>
      `/api/v1/assessment/calculate-assessment-score/${driveId}`,
    setDriveSettings: (driveId: string) =>
      `/api/v1/drive-config/update-candidate-drive-setting/${driveId}`,
    saveRetriggerPipeline: (driveId: string) =>
      `/api/v1/drive-config/process-drive-jd-manually/${driveId}`,
    getAllActiveScheduleDrive:
      '/api/v1/drive-config/get-all-active-drives-for-schedule',
    resetLastAttemptOfCandidate: '/api/v1/drive-config/reset-exam-attempt',
    deRegisterCandidateFromDrive: '/api/v1/drive-config/unregister-user',
    generateConsolidatedReport:
      '/api/v1/reports/drive-config/generate-consolidated-report',
    getAllReattemptsListForCandidate: '/api/v1/drive-config/get-past-attempts/',
    generateQuestionUsingAI:
      '/api/v1/practice-bot/generate-questions-using-AI/',
    categoriseQuestions: '/api/v1/practice-bot/categorise-questions/',
    resumeUrlForWorkdayUsers: '/api/v1/file/signed/url/s3/',
    uploadFileFordataUpload: '/api/v1/staffing-upload/upload-excel',
    //  uploadAllFilesSavePersonDetails :"/api/v1/staffing-upload/save-person-details",
    getAllUploadedData: '/api/v1/staffing-upload/get-all',
    staffingUploadDownloadExcel: '/api/v1/staffing-upload/download-excel/',
    getAllStaffingSR: '/api/v1/staffing-sr/get-all',
    getAllStaffingCandidate: '/api/v1/staffing-employee/get-all',
    staffingEmployeeOptions: '/api/v1/staffing-employee/options',
    getAllPM: '/api/v1/staffing-employee/get-all-pm',
    getAllFiltersData: '/api/v1/staffing-sr/get-all-filters-data',
    getCandidateDetailsAndScore:
      '/api/v1/drive-config/get-candidate-details-and-score', // dummmy api urls
    getAllBenchEmployee: '/api/v1/staffing-employee/get-all-bench-employee',
    getSRAndEmployeeDetailsForMail:
      '/api/v1/staffing-employee/get-sr-and-employee-details-for-mail',
    getStaffingHistory: '/api/v1/staffing-history/get-all',
    sendMailToPM: '/api/v1/staffing-employee/send-mail-to-PM',
    getAllSRByEmployee: '/api/v1/staffing-employee/get-all-sr-by-employee',
    getAllEmployeeForAIMatching:
      '/api/v1/staffing-employee/get-all-employee-for-ai-matching',
    getAllSRForAIMatching: '/api/v1/staffing-sr/get-all-sr-for-ai-matching',
    getStaffingCandidateProfile:
      '/api/v1/staffing-employee/get-candidate-profile/',
    getDebriefBotDataByCandidate:
      '/api/v1/practice-bot/get-debrief-bot-data-by-candidate/',
    generateStaffingSkills:
      '/api/v1/staffing-employee/generate-staffing-skills/',
    generateIQIGAIInsights:
      '/api/v1/staffing-employee/generate-iqigai-insights/',
    getCandidateProfileBySR:
      '/api/v1/staffing-employee/get-candidate-profile-by-sr/',
    getLatestUploadedExcelFiles:
      '/api/v1/staffing-upload/get-latest-uploaded-excel-files',
    cleanUploadedExcelFiles: '/api/v1/staffing-upload/clean-excel-files',
    downloadHistoryReport: '/api/v1/staffing-history/download-history-report/',
    saveCustomFilter: '/api/v1/filter/save',
    getAllCustomFilter: '/api/v1/filter/get-all',
    getAllCustomFilterByType: '/api/v1/filter/get-all-by-filter-type/',
    deleteCustomFilter: '/api/v1/filter/delete/',
    getPracticeBotSummary:
      '/api/v1/practice-bot/get-practice-bot-summary-evaluation/',
    runPracticeBotSummaryEvaluation:
      '/api/v1/practice-bot/run-practice-bot-summary-evaluation/',
    getAllPMSR: '/api/v1/staffing-sr/get-all-pm-sr',
    employeeManualMatching: '/api/v1/staffing-employee/manual-matching',
    getDataStaffingSRStats: '/api/v1/staffing-sr/sr-stats',
    getDataStaffingBenchStats: '/api/v1/staffing-employee/bench-stats',
    getAIMatchData: '/api/v1/ai-matching/get-ai-match-data/',
    excelDownloadSpocDrilldown: '/api/v1/staffing-sr/export-excel/download',
    getSpocDrillDownDataForSrs: '/api/v1/staffing-sr/spoc-details',
    getAllStaffingSRBasedOnType: '/api/v1/staffing-sr/sr-stats-list',
    getAllStaffingBenchBasedOnType:
      '/api/v1/staffing-employee/bench-stats/employees',
    getCognitiveAssessmentData:
      '/api/v1/practice-bot/get-all-cognitive-assessment-data-by-candidate/',
    getPracticeBotDataByCandidate:
      '/api/v1/practice-bot/get-all-practice-bot-data-by-candidate/',
    getAllBenchEmployeeFilterData:
      '/api/v1/staffing-sr/get-all-bench-employee-filters-data',
    getAllMappedCandidateFilterData:
      '/api/v1/staffing-sr/get-mapped-employee-filters-data',
    getAllPMViewFilterData :'/api/v1/staffing-sr/get-all-pm-filters-data',
    getAllPracticeBotDataBySR:
      '/api/v1/practice-bot/get-all-practice-bot-data-by-candidate-and-sr/',
    AddandEditQuestionsDebriefBotAdminsettings:
      '/api/v1/drive-config/edit-debrief-bot-question',
    getAllDebriefBotQuestions: '/api/v1/drive-config/get-debrief-bot-questions',
    saveAllQuestionsDebriefBotAdminsettings:
      '/api/v1/drive-config/save-debrief-bot-questions',
    deleteQuestionsDebriefBotQuestion:
      '/api/v1/drive-config/delete-debrief-bot-question/',
    sentNotifyMailToDebriefForcandidates: '/api/v1/staffing-employee/notify',
    triggerMailToCandidatefOReassessment  :'/api/v1/staffing-employee/reassessment-remainder-mail',
    generateReportForDebriefBot  :'/api/v1/staffing-employee/generate-candidate-profile-completion-excel',
    getBestAttemptReport: '/api/v1/drive-config/get-best-attempt-report/',
    generateCognitiveSummary: '/api/v1/staffing-employee/generate-cognitive-summary/',
    generateDebriefBotSummary: '/api/v1/staffing-employee/generate-debrief-bot-summary/',
    generateInterviewBotSummary: '/api/v1/staffing-employee/generate-interview-bot-summary/',
    getEmployeeHistorySrWise : '/api/v1/staffing-history/get-employee-history',
    downlaodExcelForEmployeeHistorySrWise:'/api/v1/staffing-history/download-employee-history-report/',
    generateRequirementMatchSummary: '/api/v1/staffing-employee/generate-requirement-match-summary/',
    triggerMailForReassessmentForCandidate :'/api/v1/staffing-employee/trigger-staffing-mail-for-assessment-reminder',
    generateDetailedInterviewBotTopics: '/api/v1/practice-bot/generate-detailed-interview-bot-topics',
    downloadAllActionsPerformed: '/api/v1/staffing-history/download-all-action-performed',
    downloadAllExcelFilesStaffingUploadData :'/api/v1/staffing-upload/download-all-excels/',
    generatExcelDownloadSRMetrics:'/api/v1/ai-matching/download-sr-mapping-details',
    generatExcelDownloadBenchMetrics:'/api/v1/ai-matching/download-candidate-mapping-details',
    downloadPMLoginInfoMetrics: '/api/v1/ai-matching/download-pm-login-info',
    getMapppedCandidateDataAvailablityStatus : '/api/v1/staffing-employee/get-ijp-data-status/',
    getAllTrackerData: '/api/v1/demand-tracker/get-all ',  // Get all tracker data
    getEditModeTypeJsonFordata:'/api/v1/demand-tracker/bulk-upload/columns', //  json config for all fields
    getAllCustomFilterDataForDemandTracker: '/api/v1/demand-tracker/filters',   // Get all values for filter dropdowns
    getUpdatedDataViaDerivedSrNumber: '/api/v1/demand-tracker/',   // Single sr data for Edit via DerivedSrNumber
    getAllUpdatedHistoryData:'/api/v1/get-all-history-data', // dummy api url by salem for testing purpose,
    downloadLatestExcelData:'/api/v1/demand-tracker/export',
    getSrDetailsViaDerivedSrNumber :'/api/v1/demand-tracker/',
    getAllColumnsKeysForBulkUpdate:'/api/v1/demand-tracker/bulk-upload/columns',
    downloadSampleTrackerExcel:'/api/v1/demand-tracker/bulk-upload/sample',
    bulkUploadApiForTracker :'/api/v1/demand-tracker/bulk-upload',
    getAllHistoryVersions: '/api/v1/demand-tracker/versions',
    downloadUpdatedExcelViaBulkUpload: '/api/v1/demand-tracker/versions',
    getDetailsOfSingleRowDerivedSrNumber :'/api/v1/demand-tracker/',
    updateSingleRowDerivedSrNumber :'/api/v1/demand-tracker/',
    bulkEditForTracker :'/api/v1/demand-tracker/bulk-edit',
    getDetailsBasedonDerivedSrNumber :'/api/v1/demand-tracker/'
  };
  constructor(private _http: HttpClient) {}

  // Initialize state with default values, to open jd
  private modalState$ = new BehaviorSubject<any>({
    isOpen: false,
    jobDescriptionData: null,
    descriptionPoints: [],
    keyResponsibilities: [],
  });

  // Expose as an observable so components can subscribe to changes
  state$ = this.modalState$.asObservable();

  // Open jd modal
  openJDModal(data: any) {
    const jobDescriptionData = {
      srNumber: data?.srNumber ?? data?.srId,
      jobDescription: data?.jobDescription,
      isBackButtonVisible: data.isBackButtonVisible,
    };

    const parsedData = this.parseJobDescription(
      jobDescriptionData.jobDescription || '',
    );

    this.modalState$.next({
      isOpen: true,
      jobDescriptionData,
      descriptionPoints: parsedData.descriptionPoints,
      keyResponsibilities: parsedData.keyResponsibilities,
    });
  }

  // Close jd modal and reset state
  closeJDModal() {
    this.modalState$.next({
      isOpen: false,
      jobDescriptionData: null,
      descriptionPoints: [],
      keyResponsibilities: [],
    });
  }

  private parseJobDescription(text: string) {
    const descriptionPoints: string[] = [];
    const keyResponsibilities: { title: string; points: string[] }[] = [];

    const blocks = text
      .split('\n')
      .map((line) => line.trim())
      .filter((line) => line.length);

    let currentSection: { title: string; points: string[] } | null = null;
    let isInResponsibilities = false;

    blocks.forEach((line) => {
      if (line.endsWith(':')) {
        isInResponsibilities = true;
        currentSection = { title: line.replace(':', ''), points: [] };
        keyResponsibilities.push(currentSection);
      } else if (isInResponsibilities && currentSection) {
        currentSection.points.push(line);
      } else {
        descriptionPoints.push(line);
      }
    });

    return { descriptionPoints, keyResponsibilities };
  }

  private calculationModalState$ = new BehaviorSubject<any>({
    isOpen: false,
    data: null,
  });

  calcState$ = this.calculationModalState$.asObservable();

  /**
   * Opens the calculation details modal with provided data
   * @param data - Pre-formatted calculation details data
   */
  openCalculationDetailsModal(data: any) {
    this.calculationModalState$.next({
      isOpen: true,
      data: data,
      isBackButtonVisible: data.isBackButtonVisible,
    });
  }

  // Recommned to pm
  private recommendCandidateModalSubject = new BehaviorSubject<RecommendModalWrapper>({
    isOpen: false,
    data: null,
  });
  RecommendmodalState$ = this.recommendCandidateModalSubject.asObservable();

  openRecommendedToPmPopup(data: RecommendModalData) {
    this.recommendCandidateModalSubject.next({
      isOpen: true,
      data,
    });
  }

  closeRecommendedToPmPopup() {
    this.recommendCandidateModalSubject.next({
      isOpen: false,
      data: null,
    });
  }


  // Reject Recommendation Modal Subject
  private openRejectRecommendedPopupSubject = new Subject<RejectModalWrapper>();

  private rejectReccommended$ = new BehaviorSubject<any>({
    isOpen: false,
    data: null,
  });
  rejectModalState$ = this.rejectReccommended$.asObservable();


  openRejectRecommendedPopup(data: any) {
    this.rejectReccommended$.next({
      isOpen: true,
      data : data,
      isBackButtonVisible: data.isBackButtonVisible,
    });
  }

  closeRejectRecommendedPopup() {
    this.rejectReccommended$.next({
      isOpen: false,
      data: null,
    });
  }



  // Block Candidate Modal State
  private blockCandidateSubject = new BehaviorSubject<{ isOpen: boolean; data: BlockCandidateModalData | null,isBackButtonVisible?:boolean }>({
    isOpen: false,
    data: null,
  });
  blockCandidateState$ = this.blockCandidateSubject.asObservable();

  openBlockCandidatePopup(data: BlockCandidateModalData) {
    this.blockCandidateSubject.next({
      isOpen: true,
      data: data,
      isBackButtonVisible: data.isBackButtonVisible,
    });
  }

  closeBlockCandidatePopup() {
    this.blockCandidateSubject.next({
      isOpen: false,
      data: null,
    });
  }

  // Unmap Candidate Modal State
  private unmapCandidateSubject = new BehaviorSubject<{ isOpen: boolean; data: UnmapCandidateModalData | null }>({
    isOpen: false,
    data: null,
  });
  unmapCandidateState$ = this.unmapCandidateSubject.asObservable();

  openUnmapCandidatePopup(data: UnmapCandidateModalData) {
    this.unmapCandidateSubject.next({
      isOpen: true,
      data: data,
    });
  }

  closeUnmapCandidatePopup() {
    this.unmapCandidateSubject.next({
      isOpen: false,
      data: null,
    });
  }

  private srDetailsModalStateSubject = new BehaviorSubject<{ isOpen: boolean; data: any,dropdownValues:any,dynamicColumns:any }>({
    isOpen: false,
    dropdownValues:{},
    dynamicColumns : [],
    data: null,
  });
  srDetailsModalState$ = this.srDetailsModalStateSubject.asObservable();

  openEditSrDetailsModal(data: any,dropdownData:any,columns:any) {
  // const defaultData = {
  //     srNumber: 'SR-30324',
  //     flowStatus: 'Select valid field',
  //     prioritizationOfDemand: 'Select valid field',
  //     srOwner: 'Enter name...',
  //     projectManagerName: 'Enter name...',
  //     personIdentified: 'Enter name...',
  //     empId: 'Enter value...',
  //     trainAndDeploy: 'Select valid field',
  //     offeredLocation: 'Select location...',
  //     offeredGrade: 'Select grade...',
  //     offeredDesignation: 'e.g. senior manager...',
  //     offeredDate: '',
  //     joiningDate: '',
  //     movedToHiringDate: '',
  //     notes: 'Enter any additional context for this request...',
  //   };

    this.srDetailsModalStateSubject.next({
      isOpen: true,
      dynamicColumns : columns,
      dropdownValues :dropdownData,
      data: data ,
    });
  }

  closeEditSrDetailsModal() {
    this.srDetailsModalStateSubject.next({
      isOpen: false,
       dynamicColumns : [],
      dropdownValues:{},
      data: null,
    });
  }

  /**
   * Fetches calculation details data for a specific employee and SR, then opens the modal
   * @param employeeId - The employee ID to fetch data for
   * @param srNumber - The SR number to fetch data for
   */
  fetchAndOpenCalculationDetailsModal(
    employeeId: string,
    srNumber: string,
    typeClick: string,
  ) {
    this.getAIMatchData(employeeId, srNumber).subscribe({
      next: (response) => {
        // Handle updated response format with status, statusCode, and data fields
        if (response?.statusCode === 200 && response?.data) {
          // Extract the data object from the response
          const apiData = response.data;

          // Validate that required fields are present
          if (this.isValidCalculationData(apiData)) {
            // Format the data using the same formatting logic
            const formattedData = this.formatCalculationDetails(apiData);
            this.openCalculationDetailsModal({
              ...formattedData,
              isBackButtonVisible: typeClick == 'PopUpClick',
            });
          } else {
            console.error(
              'Invalid calculation data structure received:',
              apiData,
            );
          }
        } else {
          console.error(
            'Error fetching calculation details:',
            response?.message || response,
          );
        }
      },
      error: (err) => {
        console.error('API error fetching calculation details:', err);
      },
    });
  }

  /**
   * Validates that the calculation data has all required fields
   * @param apiData - The data object from the API response
   * @returns true if all required fields are present, false otherwise
   */
  private isValidCalculationData(apiData: any): boolean {
    const requiredFields = [
      'totalJdMustHaveSkillCount',
      'totalJdGoodToHaveSkillCount',
      'totalJdNiceToHaveSkillCount',
      'totalMustHavePointerPool',
      'mustHavePointerPerSkill',
      'totalGoodToHavePointerPool',
      'goodToHavePointerPerSkill',
      'totalNiceToHavePointerPool',
      'niceToHavePointerPerSkill',
      'totalPointerAvailable',
      'totalPointerEarned',
      'finalScore',
    ];

    return requiredFields.every((field) => apiData.hasOwnProperty(field));
  }

  /**
   * Formats raw API response into calculation details structure
   * @param apiData - Raw API response data
   * @returns Formatted calculation details object
   */
  private formatCalculationDetails(apiData: any) {
    const convertToArray = (
      skills: string | string[] | null | undefined,
    ): string[] => {
      if (!skills) return [];
      if (Array.isArray(skills)) return skills;
      if (typeof skills === 'string')
        return skills
          .split(';')
          .map((s) => s.trim())
          .filter((s) => s);
      return [];
    };

    const buildSection = (
      title: string,
      totalCount: number,
      pointer: number,
      matchedSkills: string | string[] | null | undefined,
      gapSkills: string | string[] | null | undefined,
    ) => {
      const matchedArray = convertToArray(matchedSkills);
      const gapArray = convertToArray(gapSkills);

      const matchedItems = matchedArray.map((skill: string) => ({
        name: typeof skill === 'string' ? skill.trim() : skill,
        type: 'matched',
        description: ` Present, experience met. Awarded ${Number(pointer?.toFixed(2))} points.`,
        points: Number(pointer?.toFixed(2)),
      }));

      const gapItems = gapArray.map((skill: string) => ({
        name: typeof skill === 'string' ? skill.trim() : skill,
        type: 'gap',
        description: ' Not Present, experience not met. Awarded 0 points.',
        points: 0,
      }));

      return {
        title: `${title}: ${totalCount} skills, each weighted ${Number(pointer?.toFixed(2))} points`,
        matchedItems,
        gapItems,
      };
    };

    const sourceItems = [];

    let interviewWeight = 0;
    let assessmentWeight = 0;
    let selfDeclaredWeight = 0;

    const hasInterview = apiData.interviewScore != null;
    const hasAssessment = apiData.assessmentScore != null;

    if (hasInterview && hasAssessment) {
      // Case 3: Both interview and assessment present - High Confidence
      interviewWeight = 50;
      assessmentWeight = 10;
      selfDeclaredWeight = 40;
    } else if (hasInterview && !hasAssessment) {
      // Case 4: Interview only - Medium Confidence
      interviewWeight = 70;
      selfDeclaredWeight = 30;
    } else if (!hasInterview && hasAssessment) {
      // Case 2: Assessment only - Medium Confidence
      assessmentWeight = 30;
      selfDeclaredWeight = 70;
    } else {
      // Case 1: No interview, no assessment - Low Confidence
      selfDeclaredWeight = 100;
    }

    if (hasInterview) {
      sourceItems.push({
        label: 'SR Specific Interview Taken',
        value: `${interviewWeight}%`,
      });
    }

    if (hasAssessment) {
      sourceItems.push({
        label: 'Skill based Assessment',
        value: `${assessmentWeight}%`,
      });
    }

    sourceItems.push({
      label: 'Self Declared Skills',
      value: `${selfDeclaredWeight}%`,
    });

    const mapSkills = (skillObj: Record<string, number> | null | undefined) => {
      if (!skillObj) return [];

      return Object.keys(skillObj).map((key) => ({
        name: key,
        score: skillObj[key],
      }));
    };

    return {
      heading: 'Calculation Details',

      sourceWeightDistribution: {
        title: 'Weight Distribution Based On Source:',
        items: sourceItems,
      },

      interviewDetails: hasInterview
        ? {
            title: 'Interview Score Details:',
            finalScore: Number(
              ((interviewWeight / 100) * apiData.interviewScore).toFixed(2),
            ),
            formula: `${interviewWeight}% x Avg Interview Skill Score`,
            avgScore: apiData.interviewScore,
            skills: mapSkills(apiData.interviewSkillScore),
          }
        : null,

      assessmentDetails: hasAssessment
        ? {
            title: 'Assessment Score Details:',
            finalScore: Number(
              ((assessmentWeight / 100) * apiData.assessmentScore).toFixed(2),
            ),
            formula: `${assessmentWeight}% x Avg Assessment Skill Score`,
            avgScore: apiData.assessmentScore,
            skills: mapSkills(apiData.assessmentSkillScore),
          }
        : null,

      selfDeclaredTitle: 'Self Declared Score Details:',

      weightSummaryTitle: 'Weight Distribution based on Priority Skills:',
      weightSummary: [
        {
          label: 'Total Must Have Skills Weight',
          value: apiData.totalMustHavePointerPool,
        },
        {
          label: 'Total Good to Have Skills Weight',
          value: apiData.totalGoodToHavePointerPool,
        },
        {
          label: 'Total Nice to Have Skills Weight',
          value: apiData.totalNiceToHavePointerPool,
        },
      ],

      sections: [
        buildSection(
          'Must Skills',
          apiData.totalJdMustHaveSkillCount,
          apiData.mustHavePointerPerSkill,
          apiData.matchedMustHaveSkills,
          apiData.mustHaveGapSkills,
        ),
        buildSection(
          'Good to Have Skills',
          apiData.totalJdGoodToHaveSkillCount,
          apiData.goodToHavePointerPerSkill,
          apiData.matchedGoodToHaveSkills,
          apiData.goodToHaveGapSkills,
        ),
        buildSection(
          'Nice to Have Skills',
          apiData.totalJdNiceToHaveSkillCount,
          apiData.niceToHavePointerPerSkill,
          apiData.matchedNiceToHaveSkills,
          apiData.niceToHaveGapSkills,
        ),
      ],

      totalPointerAvailable: apiData.totalPointerAvailable,
      totalPointerEarned: apiData.totalPointerEarned,
      finalScore: apiData.finalScore,
      confidence: apiData.confidence,
      // confidence: 'High Confidence', // Set to Low Confidence as default since confidence value is not coming from API currently

      penalties: [
        { label: 'Duplicate', value: apiData.penaltyApplicationDuplicate },
        { label: 'Overload', value: apiData.penaltyApplicationOverload },
        {
          label: 'Low Relevance',
          value: apiData.penaltyApplicationLowRelevance,
        },
        { label: 'Generic', value: apiData.penaltyApplicationGeneric },
        {
          label: 'Location Mismatch Penalty',
          value: apiData.locationMismatchPenalty,
        },
        {
          label: 'Department Mismatch Penalty',
          value: apiData.departmentMismatchPenalty,
        },
        {
          label: 'Function Mismatch Penalty',
          value: apiData.functionMismatchPenalty,
        },
        {
          label: 'Grade Mismatch Penalty',
          value: apiData.gradeMismatchPenalty,
        },
      ].filter((p) => p.value && p.value !== 0 && p.value !== null),
    };
  }

  closeCalculationDetailsModal() {
    this.calculationModalState$.next({
      isOpen: false,
      data: null,
    });
  }

  addScheduleDrives(
    requestPayload: ScheduleDrive,
  ): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.addScheduleDrive,
      requestPayload,
    );
  }

  getAssessmentDetail(requestPayload): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAssessmentDetails,
      requestPayload,
    );
  }

  getDriveDetailsById(requestPayload): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getDriveById + requestPayload,
    );
  }

  getDriveDetail(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getDriveDetails,
      requestPayload,
    );
  }

  getAllUsersFordrive(requestPayload): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllUsersOfDrive,
      requestPayload,
    );
  }

  getAllInvitedUsersFordrive(requestPayload): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllInvitedUsersOfDrive,
      requestPayload,
    );
  }

  getAllConsolidatedErrorsForWorkday(
    requestPayload,
  ): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.workDayConsolidatedErrors,
      requestPayload,
    );
  }

  setAssessmentDriveSetting(
    requestPayload,
    driveId: string,
  ): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.setDriveSettings(driveId),
      requestPayload,
    );
  }
  saveRetriggerPipelineSetting(driveId: string): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.saveRetriggerPipeline(driveId),
    );
  }

  getSectionScore(driveAssessmentId): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.candidateViewDetails,
      driveAssessmentId,
    );
  }

  downloadReportsForCandiadte(requestPayload): Observable<ApiResponse<any>> {
    let url = this.baseUrl;
    return this._http.post<ApiResponse<any>>(
      url + this.apiUrls.downloadReports,
      requestPayload,
    );
  }

  getProctoringImages(id, driveId): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getProctoringImages + id + '/' + driveId,
    );
  }

  downloadReportForWorkdayUsers(driveId: string): Observable<ApiResponse<any>> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.generateReportForWodayUsers + driveId,
    );
  }

  getResumeUrlForWorkdayUsers(id: string): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.resumeUrlForWorkdayUsers + id,
    );
  }

  downloadReportsForAllCandiadte(requestPayload): Observable<ApiResponse<any>> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.downloadReportsForAllCandidates + requestPayload,
    );
  }

  generateReportsForAllCandiadte(requestPayload): Observable<ApiResponse<any>> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.generateReportsForDownload + requestPayload,
    );
  }

  resetCandidatesPassword(candidateId: string): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.resetPasswordForCandidate + candidateId,
      {},
    );
  }

  unblockCandidateById(candidateId: string): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.unblockCandidate + candidateId,
      {},
    );
  }

  generateReportForTwoWayOnly(callId: any): Observable<any> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.twoWayReportGenerate + callId,
    );
  }

  downloadReportForTwoWayOnly(callId: any): Observable<any> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.twoWayReportDownload + callId,
    );
  }

  getCandidateProfile(candidateId): Observable<any> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getCandidateProfileById + candidateId,
    );
  }

  resendReportsForWorkdayForNonInterviewBot(payload: {
    driveId: string;
    email?: [];
  }): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.resendReportsWorkdayForNoninterviewBot,
      payload,
    );
  }

  resendReportsForWorkdayInterviewBot(payload: {
    driveId: string;
    email?: [];
  }): Observable<any> {
    let url = this.baseUrl;
    return this._http.post<ApiResponse<any>>(
      url + this.apiUrls.resendReportsWorkdayInterviewBot,
      payload,
    );
  }

  resendInviteForWorkday(payload: {
    driveId: string;
    email?: [];
  }): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.resendInviteForWorkday,
      payload,
    );
  }

  viewCandidateDriveById(candidateId: string): Observable<any> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.viewDrivesOfCandidateById + candidateId,
    );
  }

  reEvaluateInterviewBot(callId: string): Observable<any> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.reEvaluateInterviewBot + callId,
    );
  }

  mergeChunksForEachCandiadte(requestPayload): Observable<any> {
    let url = this.baseUrl;
    return this._http.post<ApiResponse<any>>(
      url + this.apiUrls.mergeChunksInCandidate,
      requestPayload,
    );
  }

  extendScheduledDrive(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.extendScheduledDrive,
      requestPayload,
    );
  }

  unMergedChunksFiles(
    appUserId,
    driveId,
    assessmentDriveSetId,
    chunkType,
  ): Observable<any> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl +
        this.apiUrls.unMergeChunkFiles +
        appUserId +
        '/' +
        driveId +
        '/' +
        assessmentDriveSetId +
        '/' +
        chunkType,
    );
  }

  getAllPrimaryDrives(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllPrimaryDrives,
      requestPayload,
    );
  }

  downloadMergedVideo(driveId: any): Observable<any> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.downloadMergedVideo + '/' + driveId,
    );
  }

  mergeAllCandidateFeeds(requestPayload): Observable<any> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.mergeAllCandidateFeeds + requestPayload,
    );
  }
  downloadMultipleDriveReport(requestPayload): Observable<ApiResponse<any>> {
    let url = this.baseUrl;
    return this._http.post<ApiResponse<any>>(
      url + this.apiUrls.downloadMultipleDrive,
      requestPayload,
    );
  }

  getShortlistDrive(requestPayload) {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getShortlistDrive,
      requestPayload,
    );
  }

  blackListCandidate(requestPayload) {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.blackListCandidate + requestPayload,
    );
  }

  getAllCandidateList(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllCandidates,
      requestPayload,
    );
  }
  getAllConsolidatedReports(requestPayload): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllConsolidatedReportPagination,
      requestPayload,
    );
  }

  generateConsolidatedReport(reportsPayload: any): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.generateConsolidatedReport,
      reportsPayload,
    );
  }

  downloadProctoringReport(requestPayload): Observable<any> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.downloadProctoringReport + requestPayload,
    );
  }

  sendMailToUser(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.sendMailToUser,
      requestPayload,
    );
  }

  shortListData(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.shortListCandidates,
      requestPayload,
    );
  }

  shortListByDrive(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.shortListByDrive,
      requestPayload,
    );
  }

  getShortListedData(requestPayload: any): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getShortListedData,
      requestPayload,
    );
  }

  uploadCSVFile(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.uploadCSVFile,
      requestPayload,
    );
  }

  AIProctoringResult(userAssessmentDriveSetId: any): Observable<any> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.AIProctoringResult + userAssessmentDriveSetId,
    );
  }

  mergeShortlistedFeed(requestPayload): Observable<any> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.mergeShortlistedFeed + requestPayload,
    );
  }

  downloadAllVideoResponse(driveId: any): Observable<any> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.downloadAllVideoResponse + driveId,
    );
  }

  downloadShortlistedVideoResponse(driveId: any): Observable<any> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.downloadShortlistedVideoResponse + driveId,
    );
  }

  mergeShortlistedCandidate(driveId: any): Observable<any> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.mergeShortlistedCandidate + driveId,
    );
  }

  downloadReportForShortlisted(requestPayload): Observable<ApiResponse<any>> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.downloadReportForShortlisted + requestPayload,
    );
  }

  downloadAllReports(driveId: any): Observable<any> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.downloadAllReports + driveId,
    );
  }

  saveShortlistType(requestPayload: any): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.saveShortlistType,
      requestPayload,
    );
  }

  addCandidateToShortlist(requestPayload: any): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.addCandidateToShortlist,
      requestPayload,
    );
  }

  removeCandidateFromShortlist(requestPayload: any): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.removeCandidateFromShortlist,
      requestPayload,
    );
  }

  downloadQuestionExplanationReport(driveId: any): Observable<any> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.downloadQuestionExplanationReport + driveId,
    );
  }

  getAllGeneratedReports(driveId: any): Observable<any> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.getAllGeneratedReports + driveId,
    );
  }

  downloadExcelReports(fileId: any): Observable<any> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.downloadExcelReports + fileId,
    );
  }
  downloadAllCandidateBotAssessmentReport(fileId: any): Observable<any> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.downloadAllCandidateBotAssessmentReport + fileId,
    );
  }

  allAssessmentReport(driveId: any): Observable<any> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.allAssessmentReport + driveId,
    );
  }
  allCandidateBotAssessmentReport(driveId: any): Observable<any> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.allCandidateBotAssessmentReport + driveId,
    );
  }

  shortlistedAssessmentReport(driveId: any): Observable<any> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.shortlistedAssessmentReport + driveId,
    );
  }

  allCandidateMergedUrl(driveId: any): Observable<any> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.allCandidateMergedUrl + driveId,
    );
  }

  generateShortlistedMergedUrl(driveId: any): Observable<any> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.generateShortlistedMergedUrl + driveId,
    );
  }

  generateAllCandidateAssessmentSummaryReport(driveId: any): Observable<any> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.generateAllCandidateAssessmentSummaryReport + driveId,
    );
  }
  generateShortlistedCandidateAssessmentSummaryReport(
    driveId: any,
  ): Observable<any> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url +
        this.apiUrls.generateShortlistedCandidateAssessmentSummaryReport +
        driveId,
    );
  }
  generateNonAttemptedCandidateAssessmentReport(driveId: any): Observable<any> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url +
        this.apiUrls.generateNonAttemptedCandidateAssessmentReport +
        driveId,
    );
  }

  allInterviewResponse(driveId: any): Observable<any> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.allInterviewResponse + driveId,
    );
  }

  shortlistedInterviewResponse(driveId: any): Observable<any> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.shortlistedInterviewResponse + driveId,
    );
  }
  popularAssestementData(): Observable<any> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getPupularAssesment,
    );
  }
  getcountActiveDrive(): Observable<any> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getcountActiveDrive,
    );
  }

  experienceCandidateChart(): Observable<any> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.experienceCandidateChart,
    );
  }
  getAssessmentDetailDashboard(requestPayload): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAssessmentDetailDashboard,
      requestPayload,
    );
  }
  QuestionExplanationReport(driveId: any): Observable<any> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.QuestionExplanationReport + driveId,
    );
  }
  detectedMonitor(
    candidateId: any,
    userAssessmentDriveSetId: any,
  ): Observable<any> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl +
        this.apiUrls.detectedMonitorReport +
        candidateId +
        '/' +
        userAssessmentDriveSetId,
    );
  }

  candidateAudioProcess(requestPayload: any): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.candidateAudioProcess,
      requestPayload,
    );
  }

  candidateCodingResult(requestPayload: any): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.candidateCodingResult,
      requestPayload,
    );
  }

  saveDriveJD(requestPayload: any): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.saveDriveJD,
      requestPayload,
    );
  }

  candidateProctoringProcess(requestPayload: any): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.candidateProctoringProcess,
      requestPayload,
    );
  }

  updateDriveStatus(driveId: string) {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.updateDriveStatus(driveId),
      {},
    );
  }

  getChatBetweenBotAndCandidate(callId): Observable<any> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.chatBtwnBotAndCandidate + callId,
    );
  }

  getInterviewBotScore(callId): Observable<any> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getInterviewBotScore + callId,
    );
  }

  getInterviewTimestamps(callId): Observable<any> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getInterviewTimestamps + callId,
    );
  }

  sendCandidateEmail(userAssessmentDriveSetId: any): Observable<any> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.sendCandidateEmail + userAssessmentDriveSetId,
    );
  }

  getAllActiveScheduleDrive(requestPayload): Observable<any> {
    return this._http.post<any>(
      this.baseUrl + this.apiUrls.getAllActiveScheduleDrive,
      requestPayload,
    );
  }

  resetLastattemptOfCandidateFromDrive(requestPayload): Observable<any> {
    return this._http.patch<any>(
      this.baseUrl + this.apiUrls.resetLastAttemptOfCandidate,
      requestPayload,
    );
  }

  deRegisterCandidateFromDrive(requestPayload): Observable<any> {
    return this._http.patch<any>(
      this.baseUrl + this.apiUrls.deRegisterCandidateFromDrive,
      requestPayload,
    );
  }

  getAllReattempts(driveId: string, candidateId: string) {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl +
        this.apiUrls.getAllReattemptsListForCandidate +
        driveId +
        '/' +
        candidateId,
    );
  }

  generateQuestionUsingAI(questionTopic: any): Observable<any> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.generateQuestionUsingAI + questionTopic,
    );
  }

  categoriseQuestions(driveId: any): Observable<any> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.categoriseQuestions + driveId,
    );
  }

  //Upload file api-> Data upload
  uploadStaffingExcel(
    formData: any,
    dataset: string,
  ): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl +
        this.apiUrls.uploadFileFordataUpload +
        '?dataset=' +
        dataset,
      formData,
    );
  }

  //  // Save person details ->Start iqigai mapping
  // savePersonDetailsAfterUploading(requestPayload: any): Observable<ApiResponse<any>> {
  //   return this._http.post<ApiResponse<any>>(
  //     this.baseUrl + this.apiUrls.uploadAllFilesSavePersonDetails,
  //     requestPayload
  //   );
  // }

  // GET ALL
  getAllUploadedData(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllUploadedData,
      requestPayload,
    );
  }

  downlaodStaffingExcelViakey(key: string): Observable<ApiResponse<any>> {
     let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.staffingUploadDownloadExcel + key,
    );
  }


  downlaodStaffingAllActiosnPerformed(): Observable<ApiResponse<any>> {
     let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.downloadAllActionsPerformed ,
    );
  }

  downlaodEmployeeHistoryByEmployeeId(empId: string): Observable<ApiResponse<any>> {
     let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.downlaodExcelForEmployeeHistorySrWise + empId,
    );
  }

  downloadAllExcelFilesStaffingUploadData(aiMatchExcelId:any): Observable<ApiResponse<any>> {
     let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.downloadAllExcelFilesStaffingUploadData  + aiMatchExcelId,
    );
  }

  getAllStaffingSR(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllStaffingSR,
      requestPayload,
    );
  }

  getAllStaffingSRBasedOnType(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllStaffingSRBasedOnType,
      requestPayload,
    );
  }

  getAllStaffingBenchBasedOnType(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllStaffingBenchBasedOnType,
      requestPayload,
    );
  }

  getAllStaffingCandidate(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllStaffingCandidate,
      requestPayload,
    );
  }

  getEmployeeHistorySrWise(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getEmployeeHistorySrWise,
      requestPayload,
    );
  }

  staffingEmployeeOptions(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.staffingEmployeeOptions,
      requestPayload,
    );
  }

  getAllPM(): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllPM,
    );
  }

  // Post api for displaying filtered data on left panel filters for sr view
  getAllFiltersData(requestPayload: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllFiltersData,
      requestPayload,
    );
  }

  // downloadLatestExcel via download in options dropdown
  downloadTrackerLatestExcel(requestPayload: any):Observable<HttpResponse<Blob>> {
    return this._http.post<Blob>(
      this.baseUrl + this.apiUrls.downloadLatestExcelData,
      requestPayload, {observe: 'response',responseType: 'blob' as 'json'}
    );
  }

  //  downloadS ample Tracker Excel
  downloadSampleTrackerExcel(): Observable<HttpResponse<Blob>>  {
    return this._http.get<Blob>(
      this.baseUrl + this.apiUrls.downloadSampleTrackerExcel, {observe: 'response',responseType: 'blob' as 'json'}
    );
  }

  getDetailsBasedonDerivedSrNumber(derievedSrNumber: string): Observable<ApiResponse<any>> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.getDetailsBasedonDerivedSrNumber + derievedSrNumber +'/details',
    );
  }

  downloadTrackerVersionExcel(version: number | string): Observable<HttpResponse<Blob>> {
    return this._http.get<Blob>(
      `${this.baseUrl}${this.apiUrls.getAllHistoryVersions}/${version}/export`,
      { observe: 'response', responseType: 'blob' as 'json' }
    );
  }

  downloadUpdatedTrackerVersionExcel(version: number | string): Observable<HttpResponse<Blob>> {
    return this._http.get<Blob>(
      `${this.baseUrl}${this.apiUrls.downloadUpdatedExcelViaBulkUpload}/${version}/export-before`,
      { observe: 'response', responseType: 'blob' as 'json' }
    );
  }

  // downloadErrorFileTrackerForBulkUpload
  downloadErrorFileTrackerForBulkUpload(batchId: number | string): Observable<HttpResponse<Blob>> {
    return this._http.get<Blob>(
      `${this.baseUrl}${this.apiUrls.bulkUploadApiForTracker}/${batchId}/errors`,
      { observe: 'response', responseType: 'blob' as 'json' }
    );
  }

  restoreHistoryVersion(version: number | string): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      `${this.baseUrl}${this.apiUrls.getAllHistoryVersions}/${version}/restore`,
      {}
    );
  }

  // get SrDetails Via DerivedSrNumber
  getSrDetailsViaDerivedSrNumber(derivedSrNumber:string): Observable<ApiResponse<any>> {
      let url = this.baseUrl;
      return this._http.get<ApiResponse<any>>(
        url + this.apiUrls.getSrDetailsViaDerivedSrNumber  + derivedSrNumber,
      );
  }


  //  single row get api for  DerivedSrNumber
  getDetailsOfSingleRowDerivedSrNumber(derivedSrNumber:string): Observable<ApiResponse<any>>  {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getDetailsOfSingleRowDerivedSrNumber + encodeURIComponent(derivedSrNumber)
    );
  }

   // update single row update api for  DerivedSrNumber
  updateDetailsOfSingleRowDerivedSrNumber(derivedSrNumber:string, requestPayload: any): Observable<ApiResponse<any>>  {
    return this._http.put<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.updateSingleRowDerivedSrNumber + encodeURIComponent(derivedSrNumber), requestPayload
    );
  }

   // bulkEditModeForTracker when click on edit mode , update api
  bulkEditModeForTracker(requestPayload:any): Observable<ApiResponse<any>>  {
    return this._http.put<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.bulkEditForTracker, requestPayload
    );
  }

  // Get api for displaying data on custom filters for sr view
  getAllCustomFiltersData(): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllFiltersData
    );
  }

  getAllCustomFiltersDataForDemandTracker(): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllCustomFilterDataForDemandTracker
    );
  }

  // search for dropdown fields
  getAllfiltersApiWithSearch(requestPayload:any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllCustomFilterDataForDemandTracker,requestPayload
    );
  }

  // get EditMode Type Config For Json
  getEditModeTypeConfigForJson(): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getEditModeTypeJsonFordata
    );
  }


  // Bulk uplaod api with columns to update
  bulkUploadApiForTracker( formData: any, columns: string[]): Observable<ApiResponse<any>> {
      const params = new HttpParams()
        .set('columns', columns.join(','));

      return this._http.post<ApiResponse<any>>(
        this.baseUrl + this.apiUrls.bulkUploadApiForTracker,
        formData,
        { params }
      );
  }  

   // getAll ColumnsKeys For BulkUpdate
  getAllColumnsKeysForBulkUpdate(): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllColumnsKeysForBulkUpdate
    );
  }

  



  // Get by data by candidate id for view profile
  getCandidatesDetailsAndResults(id: string): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getCandidateDetailsAndScore + id,
    );
  }

  getAllBenchEmployee(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllBenchEmployee,
      requestPayload,
    );
  }

  getSRAndEmployeeDetailsForMail(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getSRAndEmployeeDetailsForMail,
      requestPayload,
    );
  }

  getStaffingHistory(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getStaffingHistory,
      requestPayload,
    );
  }

  sendMailToPM(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.sendMailToPM,
      requestPayload,
    );
  }

  getAllSRByEmployee(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllSRByEmployee,
      requestPayload,
    );
  }

  getAllEmployeeForAIMatching(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllEmployeeForAIMatching,
      requestPayload,
    );
  }

  getAllSRForAIMatching(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllSRForAIMatching,
      requestPayload,
    );
  }

  getStaffingCandidateProfile(eployeeId: string, attemptCount: number) {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl +
        this.apiUrls.getStaffingCandidateProfile +
        eployeeId +
        '/' +
        attemptCount,
    );
  }

  getDebriefBotDataByCandidate(eployeeId: string) {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getDebriefBotDataByCandidate + eployeeId,
    );
  }

  generateStaffingSkills(eployeeId: string) {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.generateStaffingSkills + eployeeId,
    );
  }

  generateIQIGAIInsights(eployeeId: string) {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.generateIQIGAIInsights + eployeeId,
    );
  }

  getCandidateProfileBySR(
    eployeeId: string,
    SRNumber: string,
    attemptCount: number,
  ) {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl +
        this.apiUrls.getCandidateProfileBySR +
        eployeeId +
        '/' +
        SRNumber +
        '/' +
        attemptCount,
    );
  }

  getLatestUploadedExcelFiles() {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getLatestUploadedExcelFiles,
    );
  }

  cleanUploadedExcelFiles(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.cleanUploadedExcelFiles,
      requestPayload,
    );
  }

  downloadHistoryReport(srNumber: string) {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.downloadHistoryReport + srNumber,
    );
  }

  saveCustomFilter(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.saveCustomFilter,
      requestPayload,
    );
  }

  
  //Demand tracker getall api
  getAllTrackerData(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllTrackerData,
      requestPayload,
    );
  }

   //get All Updated HistoryData api
  getAllUpdatedHistoryData(requestPayload): Observable<any> {
    const page = Number(requestPayload?.page ?? 0);
    const size = Number(requestPayload?.size ?? 10);
    const search = requestPayload?.search 

    return this.getAllHistoryVersions(String(page), size,search);
  }

  // Single sr data for Edit via DerivedSrNumber
  getdDtaToEditViaDerivedSrNumber(derivedSrNumber: string) {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getUpdatedDataViaDerivedSrNumber + derivedSrNumber,
    );
  }

  getAllCustomFilter() {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllCustomFilter,
    );
  }

  getAllCustomFilterByType(filterType: string) {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllCustomFilterByType + filterType,
    );
  }

  deleteCustomFilter(filterId: any): Observable<ApiResponse<any>> {
    return this._http.delete<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.deleteCustomFilter + filterId,
    );
  }

  getPracticeBotSummary(driveId: string, candidateID: string) {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl +
        this.apiUrls.getPracticeBotSummary +
        driveId +
        '/' +
        candidateID,
    );
  }

  runPracticeBotSummaryEvaluation(driveId: string, candidateID: string) {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl +
        this.apiUrls.runPracticeBotSummaryEvaluation +
        driveId +
        '/' +
        candidateID,
    );
  }

  getAllPMSR(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllPMSR,
      requestPayload,
    );
  }

  employeeManualMatching(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.employeeManualMatching,
      requestPayload,
    );
  }

  getStaffingSRStats() {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getDataStaffingSRStats,
    );
  }
  getStaffingBenchStats() {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getDataStaffingBenchStats,
    );
  }

  getAIMatchData(empId: string, srNumber: string) {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAIMatchData + empId + '/' + srNumber,
    );
  }

  // getCognitiveAssessmentData(empId: string) {
  //   return this._http.get<ApiResponse<any>>(
  //     this.baseUrl + this.apiUrls.getCognitiveAssessmentData + empId,
  //   );
  // } 
  
    getBestAttemptReport(empId: string) {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getBestAttemptReport + empId,
    );
  }

  getPracticeBotDataByCandidate(empId: string) {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getPracticeBotDataByCandidate + empId,
    );
  }
  // Post api for displaying filtered data on left panel filters for bench view
  getAllBenchEmployeeFilterData(requestPayload): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllBenchEmployeeFilterData ,requestPayload
    );
  }
// Get api for displaying data on custom filters for bench view
  getAllBenchEmployeeCustomFilterData(): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllBenchEmployeeFilterData
    );
  }
  // Post api for displaying filtered data on left panel filters for pm view
  getAllPmViewFilterData(requestPayload): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllPMViewFilterData ,requestPayload
    );
  }

 // Get api for displaying data on custom filters for pm view
  getAllPmViewCustomFilterData(): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllPMViewFilterData
    );
  }

// Post api for displaying filtered data on left panel filters for mapped candidates
  getAllMapppedCandidteFilterData(requestPayload): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllMappedCandidateFilterData ,requestPayload
    );
  }
  


  getAllPracticeBotDataBySR(empId: string, srNumber: string) {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl +
        this.apiUrls.getAllPracticeBotDataBySR +
        empId +
        '/' +
        srNumber,
    );
  }

  generatExcelDownloadSpocDrilldown(): Observable<Blob> {
    let url = this.baseUrl;
    return this._http.get(url + this.apiUrls.excelDownloadSpocDrilldown, {
      responseType: 'blob',
    });
  }


  getAllSpocDrillDownDataForSrs(page: number, size: number) {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getSpocDrillDownDataForSrs,
      { params },
    );
  }
  

  // Add QuestionsDebriefBotAdminsettings
  addEditQuestionsDebriefBotAdminsettings(
    requestPayload: any,
  ): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.AddandEditQuestionsDebriefBotAdminsettings,
      requestPayload,
    );
  }

  // Global save changes Adminsettings
  saveAllQuestionsDebriefBotAdminsettings(
    requestPayload: any[],
  ): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.saveAllQuestionsDebriefBotAdminsettings,
      requestPayload,
    );
  }

  // get allQuestionsForAdminDebriefBot
  getAllQuestionsForAdminDebriefBot(): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllDebriefBotQuestions,
    );
  }

  // Delete debrief Bot question
  deleteQuestionOfDebriefBot(sequence: number): Observable<ApiResponse<any>> {
    return this._http.delete<ApiResponse<any>>(
      `${this.baseUrl}${this.apiUrls.deleteQuestionsDebriefBotQuestion}${sequence}`,
    );
  }

  // Send Notifuication for Debrief bot to candidates
  sentNotifyMailDebriefBot(requestPayload: string[]): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.sentNotifyMailToDebriefForcandidates,
      requestPayload,
    );
  }
  
  triggerMailToCandidatefOReassesment(requestPayload: any): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.triggerMailToCandidatefOReassessment,
      requestPayload,
    );
  }

  // Debrief Bot Report(
  downlaodStaffingDebriefBotReport(): Observable<ApiResponse<any>> {
    let url = this.baseUrl;
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.generateReportForDebriefBot
    );
  }

    generateInterviewBotSummary(empId: string, driveId: string) {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.generateInterviewBotSummary + empId + '/' + driveId,
    );
  }

    generateCognitiveSummary(empId: string) {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.generateCognitiveSummary + empId
    );
  }
  
  generateDebriefBotSummary(empId: string) {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.generateDebriefBotSummary + empId
    );
  }

  generateRequirementMatchSummary(empId: string, SRnumber: string) {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.generateRequirementMatchSummary + empId + '/' + SRnumber,
    );
  }

  triggerMailForReassessmentForCandidate(requestPayload:any): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.triggerMailForReassessmentForCandidate,
      requestPayload,
    );
  }

  generateDetailedInterviewBotTopics(requestPayload:any): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.generateDetailedInterviewBotTopics,
      requestPayload,
    );
  }
  
  generatExcelDownloadSRMetrics(): Observable<Blob> {
    let url = this.baseUrl;
    return this._http.get(url + this.apiUrls.generatExcelDownloadSRMetrics, {
      responseType: 'blob',
    });
  }
  
    generatExcelDownloadBenchMetrics(): Observable<Blob> {
    let url = this.baseUrl;
    return this._http.get(url + this.apiUrls.generatExcelDownloadBenchMetrics, {
      responseType: 'blob',
    });
  }

  downloadPMLoginInfoMetrics(): Observable<Blob> {
    let url = this.baseUrl;
    return this._http.get(url + this.apiUrls.downloadPMLoginInfoMetrics, {
      responseType: 'blob',
    });
  }

  getMappedCandidateDataStatus(srNumber:string): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getMapppedCandidateDataAvailablityStatus + '/' + srNumber,
    );
  }
  
   getAllHistoryVersions(page:string, size:number,search:string): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllHistoryVersions + '?page=' + page + '&size=' + size +'&search=' + search,
    );
  }
}
